import React, { Component } from 'react';
import { Redirect, Link, history } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class AddEr extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            add_sub_effort: [],
            effort: [],
            search: [],
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            owners: [],
            product: [],
            product_line: [],
            category: [],
            category_workflow: [],
            type: [],
            team: [],
            priority: [],
            title: '',
            server: [],
            browser: [],
            microservice: [],
            os_version: [],
            supportLevels: [],
            description: '',
            ticket: 'none',
            support_level: '',
            start_date: '',
            startdate: '',
            end_date: '',
            enddate: '',
            go_live_date: '',
            golivedate: '',
            browser_version: '',
            attachments: '',
            account_managerinse: '',
            project: '',
            date_of_joining: moment(),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {
                priority: '30'
            },
            errors: {},
            error_message: '',
            checkBox: false,
            setFeature: '',
            selected_pod: ''
        }
        this.insertRequest = this.insertRequest.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onFeatureChange = this.onFeatureChange.bind(this);
        this.handleChangestartDate = this.handleChangestartDate.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
        this.handleChangeGoLiveDate = this.handleChangeGoLiveDate.bind(this);
        this.handleChangeDateOfJoining = this.handleChangeDateOfJoining.bind(this);
        this.startdateChange = this.startdateChange.bind(this);
        this.enddateChange = this.enddateChange.bind(this);
        this.golivedateChange = this.golivedateChange.bind(this);
        this.getSearchERNumber = this.getSearchERNumber.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    handleUpdateInput = (searchText) => {
        this.setState({
            searchText: searchText,
        });
        this.getERNumber(searchText);
    };

    handleNewRequest = (searchText) => {
        this.getSearchERNumber();
    };

    enterKeyPress(event) {
        if (event.key == 'Enter') {
        }
    }

    getERNumber(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getERNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.ers,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }
            })
    }
    getSearchERNumber() {
        fetch(this.state.apiUrl + '/ErRest/getSearchERNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        ers: findresponse.ers,
                        item_count: findresponse.item_count,
                    })
                    if (this.state.item_count > 0) {
                        window.location.href = '/viewER/' + findresponse.er_id;
                    }
                }
                else {
                    alert("No result found");
                }
            })
    }

    startdateChange(event) {
        this.setState({ startdate: event, start_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }
    enddateChange(event) {
        this.setState({ enddate: event, end_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }
    golivedateChange(event) {
        this.setState({ golivedate: event, go_live_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }

    goBack() {
        window.history.back();
    }
    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["title"]) {
            formIsValid = false;
            errors["title"] = "This field is required.";
        }
        if (!fields["description"] && this.state.previous_inserted_er_category != 13) {
            formIsValid = false;
            errors["description"] = "This field is required.";
        }
        if (!fields["category"]) {
            formIsValid = false;
            errors["category"] = "This field is required.";
        }
        if (!fields["priority"] && this.state.previous_inserted_er_category != 13) {
            formIsValid = false;
            errors["priority"] = "This field is required.";
        }
        if (!fields["product_line"] && this.state.previous_inserted_er_category != 13) {
            formIsValid = false;
            errors["product_line"] = "This field is required.";
        }
        if (!fields["assign_to"] && this.state.previous_inserted_er_category != 13) {
            formIsValid = false;
            errors["assign_to"] = "This field is required.";
        }
        //Er 66478 Effort mandatory
        if (!fields["effort"]) {
            formIsValid = false;
            errors["effort"] = "This field is required.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    fileSelecthandler = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }
    insertRequest(e) {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("add_request").innerHTML = "Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }

        document.getElementById("add_request").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/ErRest/InsertInitiativeRequest/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/erId/' + this.props.match.params.erId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_request").innerHTML = "Submit";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        if (findresponse.er_id) {
                            window.location.href = '/viewEr/' + this.props.match.params.erId;
                        } else {
                            window.location.href = '/er/';
                        }
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }
    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        return pattern.test(number);
    }
    onChange(event) {
        let fields = this.state.fields;
        if (event.target.name == 'category') {
            this.setState({ previous_inserted_er_category: event.target.value, setFeature: '' });
        }
        if (event.target.name == 'product_line') {
            var cbarray = document.getElementsByClassName('feature_type');
            for (var i = 0; i < cbarray.length; i++) {
                cbarray[i].checked = false;
            }
            this.setState({ selected_pod: event.target.value, setFeature: '' });
        }
        fields[event.target.name] = event.target.value;
    }
    onFeatureChange() {
        var role = document.getElementsByName('feature_type');
        this.state.setFeature = '';
        for (let i = 0; i < role.length; i++) {
            if (role[i].checked === true) {
                this.state.setFeature += role[i].value;
            }
        }
        this.setState({ setFeature: this.state.setFeature })
    }
    handleCheck(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleChangeDateOfJoining(date) {
        this.setState({
            start_date: date
        }, function () {
        });
    }

    handleChangestartDate(date) {
        this.setState({
            startDate: date,
            start_date: moment(date).format("YYYY-MM-D")
        }, function () {
        });
    }

    handleChangeEndDate(date) {
        this.setState({
            EndDate: date,
            end_date: moment(date).format("YYYY-MM-D")
        }, function () {
        });
    }

    focousOutEndDate(value) {
        if (!value) {
            this.setState({ EndDate: '' });
            this.setState({ end_date: '' });
        }
    }

    focousOutGoLiveDate(value) {
        if (!value) {
            this.setState({ GoLiveDate: '' });
            this.setState({ go_live_date: '' });
        }
    }

    handleChangeGoLiveDate(date) {
        this.setState({
            GoLiveDate: date,
            go_live_date: moment(date).format("YYYY-MM-D")
        }, function () {
        });
    }
    AddEr() {
        fetch(this.state.apiUrl + '/ErRest/AdddetailsFromEr/userAuthKey/' + this.state.userAuthKey + '/er_id/' + this.props.match.params.erId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    owners: findresponse.owner,
                    team: findresponse.team,
                    product_line: findresponse.product_line,
                    category: findresponse.category,
                    category_workflow: findresponse.category_workflow,
                    type: findresponse.type,
                    priority: findresponse.priority,
                    server: findresponse.server,
                    status: findresponse.status,
                    browser: findresponse.browser,
                    microservice: findresponse.microservice,
                    os_version: findresponse.os_version,
                    supportLevels: findresponse.supportLevels,
                    effort: findresponse.effort,
                    add_sub_effort: findresponse.add_sub_effort,
                })
            })
    }

    onToggle(obj) {
        var obj = document.getElementById('showmore')
        if (obj.classList.contains('collapsed')) {
            obj.innerHTML = 'Show More';
        } else {
            obj.innerHTML = 'Show Less';
        }
    }

    componentDidMount() {
        document.title = "Intranet | Add Request";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.AddEr();

        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $('.upload_btn .inputfile').click();

            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();

                $input.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });

                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });

            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;
                });
            } else {
                alert("Your browser doesn't support to File API")
            }
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div >
                <Header brecum_name="ER" brecum_page="Add Request" />
                <div class="right_col">
                    <span className="error">{this.state.error_message}</span>
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="Add Request" /></div>
                        <div class="form-group">
                        </div>
                        <div class="top-row-form">
                            <div class="form-group">
                                <label for="title">Title<span class="star">*</span></label>
                                <input type="text" name="title" id="title" className="form-control" onChange={this.onChange} />
                                <span class="error">{this.state.errors["title"]}</span>
                            </div>
                            <div class="form-group">
                                <label>Descriptions{this.state.previous_inserted_er_category == 13 ? '' : <span class="star">*</span>}</label>
                                <textarea class="form-control" name="description" id="description" onChange={this.onChange}></textarea>
                                <span class="error">{this.state.errors["description"]}</span>
                            </div>
                        </div>
                        <div class="form-section add row">
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Category<span class="star">*</span></label>
                                <div class="filter">
                                    <select class="form-control" name="category" id="id" onChange={this.onChange} >
                                        <option value='' selected="selected">Any</option>
                                        {
                                            this.state.category_workflow.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["category"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Priority{this.state.previous_inserted_er_category == 13 ? '' : <span class="star">*</span>}</label>
                                <div class="filter">
                                    <select class="form-control" name="priority" id="id" onChange={this.onChange} >
                                        <option value="" selected>Any</option>
                                        {
                                            this.state.priority.map((dynamicData, index) =>
                                                <option value={dynamicData.key} selected={dynamicData.key == 30 ? 'selected' : ''}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["priority"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Assigned to{this.state.previous_inserted_er_category == 13 ? '' : <span class="star">*</span>}</label>
                                <div class="filter">
                                    <select id="assign_to" class="form-control" name="assign_to" onChange={this.onChange}>
                                        <option value='all' selected="selected">Any </option>
                                        {
                                            this.state.owners.map((dynamicData, key) =>
                                                <option value={dynamicData.id} selected={dynamicData.id == this.state.userId && this.state.previous_inserted_er_category == 13 ? 'selected' : ''}>{dynamicData.name}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["assign_to"]}</span>
                            </div>
                            {/* Er 66478 Effort mandatory */}
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Effort<span class="star">*</span></label>
                                    <div class="filter">
                                        <select class="form-control" id="effort" name="effort" onChange={this.onChange}>
                                            <option value="" >Select Effort</option>
                                            {
                                                this.state.add_sub_effort.map((dynamicData, k) =>
                                                <option value={dynamicData.key} >{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                    <span class="error">{this.state.errors["effort"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Pod/Department{this.state.previous_inserted_er_category == 13 ? '' : <span class="star">*</span>}</label>
                                <div class="filter">
                                    <select id="product_id" class="form-control" name="product_line" onChange={this.onChange}>
                                        <option value='' selected="selected">Any</option>
                                        {
                                            this.state.product_line.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["product_line"]}</span>
                            </div>
                            <div class="collapse er_advance" id="collapseExample">
                                {this.state.previous_inserted_er_category == 13 ? '' : <div><div class="form-group col-sm-3 col-xs-6">
                                    <label>Server</label>
                                    <div class="filter">
                                        <select class="form-control" id="server" name="server" onChange={this.onChange}>
                                            <option value='' selected > Any</option>
                                            {
                                                this.state.server.map((dynamicData, k) =>
                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Type<span class="star"></span></label>
                                    <div class="filter">
                                        <select class="form-control" id="id" name="type" onChange={this.onChange}>
                                            {
                                                this.state.type.map((dynamicData, index) =>
                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        <span class="error">{this.state.errors["type"]}</span>
                                    </div>
                                    </div></div>}
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Ticket</label>
                                    <div class="filter">
                                        <input type="text" name="ticket" className="form-control" onChange={this.onChange} />
                                    </div>
                                </div>
                                {this.state.previous_inserted_er_category == 13 ? '' : <div class="form-group col-sm-3 col-xs-6">
                                    <label>Escalation Level</label>
                                    <div class="filter">
                                        <select class="form-control" name="support_level" id="support_level" onChange={this.onChange} >
                                            <option value="" selected="selected">Any</option>
                                            {
                                                this.state.supportLevels.map((dynamicData, index) =>
                                                    <option value={dynamicData.escalation_level}>{dynamicData.escalation_level}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                }
                                <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                    <label>Start Date</label>
                                    <div class="filter right">
                                        <DatePicker
                                            selected={this.state.startdate}
                                            onChange={this.startdateChange}
                                            placeholderText="Start Date"
                                            dateFormat="DD/MM/YYYY"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            maxDate={this.state.enddate ? this.state.enddate : (this.state.startdate ? this.state.startdate : '')}
                                            onBlur={event => this.focousOutGoLiveDate(event.target.value)}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                    <label>End Date</label>
                                    <div class="filter right">
                                        <DatePicker
                                            selected={this.state.enddate}
                                            onChange={this.enddateChange}
                                            placeholderText="End Date"
                                            dateFormat="DD/MM/YYYY"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={this.state.startdate}
                                            maxDate={this.state.golivedate}
                                            onBlur={event => this.focousOutEndDate(event.target.value)}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                                {this.state.previous_inserted_er_category == 13 ? '' : <div>
                                <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                    <label>Go-live Date</label>
                                    <div class="filter right">
                                        <DatePicker
                                            selected={this.state.golivedate}
                                            onChange={this.golivedateChange}
                                            placeholderText="Go Live Date"
                                            dateFormat="DD/MM/YYYY"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={this.state.enddate ? this.state.enddate : (this.state.startdate ? this.state.startdate : '')}
                                            onBlur={event => this.focousOutGoLiveDate(event.target.value)}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Os Version</label>
                                    <div class="filter">
                                        <select class="form-control" name="os_version" id="os_version" onChange={this.onChange} >
                                            <option value="" selected="selected">Any</option>
                                            {
                                                this.state.os_version.map((dynamicData, index) =>
                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Browser</label>
                                    <div class="filter">
                                        <select class="form-control" name="browser" id="browser" onChange={this.onChange} >
                                            <option value="" selected="selected">Any</option>
                                            {
                                                this.state.browser.map((dynamicData, index) =>
                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="form-group col-sm-3 col-xs-6">
                                    <label>Browser Version</label>
                                    <div class="filter">
                                        <input type="text" name="browser_version" className="form-control" onChange={this.onChange} />
                                    </div>
                                </div>
                                {/* <div class="form-group col-sm-3 col-xs-6">
                                    <label>Microservice</label>
                                    <div class="filter">
                                        <select class="form-control" name="microservice" id="microservice" onChange={this.onChange} >
                                            {
                                                this.state.microservice.map((dynamicData, index) =>
                                                    <option value={dynamicData.key} selected={dynamicData.key == 1 ? 'selected' : ''}>{dynamicData.value}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div> */}
                                    <div class="col-sm-3 col-xs-6">
                                        {
                                            this.state.previous_inserted_er_category == 12 && (this.state.selected_pod == 4 || this.state.selected_pod == 14 || this.state.selected_pod == 25) ?
                                                <div>
                                                    <p class="feature-check box">
                                                        <input type="radio" name="feature_type" class="feature_type" id="platform_feature" value="3" onChange={this.onFeatureChange} />
                                                        <label for="platform_feature"><span></span>{'Platform'}</label>
                                                    </p>
                                                    <p class="feature-check box">
                                                        <input type="radio" name="feature_type" class="feature_type" id="native_feature" value="2" onChange={this.onFeatureChange} />
                                                        <label for="native_feature"><span></span>{'Native(Mobile/TV)'}</label>
                                                    </p></div> : (this.state.previous_inserted_er_category == 12 && (this.state.selected_pod != 4 && this.state.selected_pod != 14 && this.state.selected_pod != 25) ? <p class="feature-check box">
                                                <input type="checkbox" name="feature_type" class="feature_type" id="major_feature" value="1" onChange={this.onFeatureChange} />
                                                <label for="major_feature"><span></span>{'Major Feature'}</label>
                                            </p> : '')
                                        }
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div class="upload">
                            <label>Add Attachment :</label>
                            <div class="upload_btn">
                                <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                <label for="file-1">
                                    <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                    <span>Choose file</span>
                                    <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                </label>
                            </div>
                        </div>
                        <button type="submit" name="add_request" id="add_request" class="btn btn-sky mob-btn" onClick={() => this.insertRequest()}>Submit</button>
                        <button className="btn btn-sky" id="showmore" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" onClick={this.onToggle.bind()}>Show More</button>
                    </div>
                </div>
            </div>
        )
    }
}
export default AddEr;


// WEBPACK FOOTER //
// ./src/components/er/AddEr.js